import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useProfileApi, UpdateProfileSettingsParams } from '@fsd/shared/api';
import { mappersLib } from '../lib';
import { ProfileWithRole } from '../types';

export const useUserStore = defineStore('user', () => {
  const profile = ref<ProfileWithRole>();

  const { getProfile, updateUserSettings } = useProfileApi();

  const fetchProfile = async () => {
    const data = await getProfile();
    profile.value = { ...profile.value, ...mappersLib.profileMapper(data) } as ProfileWithRole;
  };

  const changeSettings = async (settings: UpdateProfileSettingsParams) => {
    try {
      const response = await updateUserSettings(settings);

      if (response.status === 204 || response.status === 200) {
        fetchProfile();
      }
    } catch (error) {
      console.error('An unexpected error occurred:', error);
    }
  };

  return {
    profile,
    fetchProfile,
    changeSettings,
  };
});
